<sol-dialog [dialog]="dialog$()" (action)="onAction($event)">
  <div class="sol-dialog-content-message">
    {{ text$() | translate }}
  </div>
</sol-dialog>
